import { render, staticRenderFns } from "./WithdrawComments.vue?vue&type=template&id=46b7b9c0&scoped=true&"
import script from "./WithdrawComments.vue?vue&type=script&lang=js&"
export * from "./WithdrawComments.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawComments.vue?vue&type=style&index=0&id=46b7b9c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7b9c0",
  null
  
)

export default component.exports